var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 13.8333H18V15.5H0V13.8333H1.63636V1.33333C1.63636 1.11232 1.72256 0.900358 1.876 0.744078C2.02944 0.587797 2.23755 0.5 2.45455 0.5H10.6364C10.8534 0.5 11.0615 0.587797 11.2149 0.744078C11.3683 0.900358 11.4545 1.11232 11.4545 1.33333V13.8333H14.7273V7.16667H13.0909V5.5H15.5455C15.7625 5.5 15.9706 5.5878 16.124 5.74408C16.2774 5.90036 16.3636 6.11232 16.3636 6.33333V13.8333ZM3.27273 2.16667V13.8333H9.81818V2.16667H3.27273ZM4.90909 7.16667H8.18182V8.83333H4.90909V7.16667ZM4.90909 3.83333H8.18182V5.5H4.90909V3.83333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropDetails);
export default __webpack_public_path__ + "static/media/PropDetails.a8aaf294254637c3e6b152cfd376ac86.svg";
export { ForwardRef as ReactComponent };